import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { PodcastPage } from "@/components/PodcastPage";
import { CookieConsent } from "@/components/CookieConsent";
import { Hero } from "@/components/Hero";
import { Philosophy } from "@/components/Philosophy";
import { Experiences } from "@/components/Experiences";
import { Process } from "@/components/Process";
import { Discretion } from "@/components/Discretion";
import { About } from "@/components/About";
import { BookingSection } from "@/components/BookingSection";
import { Footer } from "@/components/Footer";

const LandingPage = () => {
  return (
    <div className="bg-[#FCF5EB] text-[#02515A] antialiased" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <Philosophy />
        <div className="h-2.5 bg-[#7D1B56]" aria-hidden="true" data-testid="divider-philosophy-experiences" />
        <Experiences />
        <Process />
        <Discretion />
        <About />
        <div className="h-2.5 bg-[#7D1B56]" aria-hidden="true" data-testid="divider-about-booking" />
        <BookingSection />
      </main>
      <Footer />
    </div>
  );
};

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <ScrollManager />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/podcast" element={<PodcastPage />} />
          <Route path="/journal" element={<Navigate to="/podcast" replace />} />
        </Routes>
        </BrowserRouter>
      </HelmetProvider>
      <CookieConsent />
      <Toaster position="bottom-center" toastOptions={{ style: { borderRadius: 0 } }} />
    </div>
  );
}

export default App;
